import KEYS from './apiDataReducers.keys';

const API_DATA_REDUCER_PATHS = {
  META_FETCH_STARTED_AT:   [KEYS.META, KEYS.META_FETCH_STARTED_AT],
  META_SAVES_IN_PROGRESS:  [KEYS.META, KEYS.META_SAVES_IN_PROGRESS],
  META_FIELDS_BEING_SAVED: [KEYS.META, KEYS.META_FIELDS_BEING_SAVED],
  META_TYPE:               [KEYS.META, KEYS.META_TYPE],
  META_TOTAL_COUNT:        [KEYS.META, KEYS.META_TOTAL_COUNT],
  META_PAGE_COUNT:         [KEYS.META, KEYS.META_PAGE_COUNT],
  META_UPDATED_AT:         [KEYS.META, KEYS.META_UPDATED_AT],
  META_ERROR:              [KEYS.META, KEYS.META_ERROR],
  META_FAILED_ATTEMPTS:    [KEYS.META, KEYS.META_FAILED_ATTEMPTS],
};


export default API_DATA_REDUCER_PATHS;


// WEBPACK FOOTER //
// ./src/reducers/apiDataReducers.paths.js